import { Action } from '@ngrx/store';
import { MerchantAPIResponse } from '../models/merchantresponse.model';

export enum EMerchantActions {
  GetMerchant = '[Merchant] Get Merchant',
  GetMerchantSuccess = '[Merchant] Get Merchant Success'
}

export class GetMerchant implements Action 
{
  public readonly type = EMerchantActions.GetMerchant;
  constructor(public payload:string) 
  {
      
  }
}

export class GetMerchantSuccess implements Action {
  public readonly type = EMerchantActions.GetMerchantSuccess;
  constructor(public payload: MerchantAPIResponse) {
    
  }
}

export type MerchantActions =
  | GetMerchant
  | GetMerchantSuccess;